import React from "react"
import { useFormContext } from "react-hook-form"

import { useEvent } from "shared/lib/useEvent"

import { ClarificationRequestForm } from "entities/clarification-requests/ui/ClarificationRequestForm"
import { FloorFormData } from "features/floor-management/types/FloorFormData"

import { useFloorFormContext } from "../contexts/FloorFormContext"

export const FloorFormClarificationRequest = React.memo(() => {
  const { isReadonly, model } = useFloorFormContext()
  const cr = model?.clarificationRequest?.data.clarificationRequest
  const hasCR = !!cr?.data
  const lastUpdatedByMember =
    model?.clarificationRequest?.data.meta.lastUpdatedByMember ?? null

  const { setValue } = useFormContext<FloorFormData>()

  const handleDismiss = useEvent(() => {
    model?.clarificationRequest?.handlers.onDelete?.()
    setValue("clarificationRequest.content", null)
  })

  return (
    <ClarificationRequestForm.Root
      clarificationRequest={cr?.data ?? null}
      isLoading={cr?.isLoading}
      lastUpdatedByMember={lastUpdatedByMember}
    >
      {hasCR ? <ClarificationRequestForm.UpdatedAt /> : null}
      <ClarificationRequestForm.TextArea
        name="clarificationRequest.content"
        readonly={isReadonly}
      />
      {hasCR && isReadonly && model?.clarificationRequest?.handlers.onDelete ? (
        <ClarificationRequestForm.DismissButton onDismiss={handleDismiss} />
      ) : null}
      {!isReadonly && model?.clarificationRequest?.data.meta.shouldShowHint && (
        <ClarificationRequestForm.Hint
          onClose={model.clarificationRequest?.handlers.onHintClose}
        />
      )}
    </ClarificationRequestForm.Root>
  )
})

FloorFormClarificationRequest.displayName = "FloorFormClarificationRequest"
